export default __webpack_public_path__ + "static/media/FamilyValuesChild.0667d7db.svg";